import type { Locales } from "@/graphql/generated";
import type { ProductType } from "@/models/ProductType";
import { entryContentExternalQueryOptions } from "@/services/cms/tanstackQuery/queryOptions/entryContentExternalQueryOptions";
import { webComponentQueryClient } from "./reactWrapper";

type PrefetchEntryContentParams<P extends ProductType> = {
  product: P;
  language: Locales;
  backendHost?: string;
  appPathPrefix?: string;
};

export function prefetchEntryContent<P extends ProductType>({
  product,
  language,
  backendHost,
  appPathPrefix,
}: PrefetchEntryContentParams<P>) {
  return webComponentQueryClient.prefetchQuery(
    entryContentExternalQueryOptions({
      product,
      language,
      backendHost,
      appPathPrefix,
    }),
  );
}
